import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Button, Form, Segment, Message } from "semantic-ui-react";

import {
    authChangePasswordInputChange,
    authToggleNewPasswordField,
    authToggleConfirmPasswordField,
    authChangePasswordRequest,
} from "../actions";

const ChangePasswordForm = ({
    inputs,
    authChangePasswordInputChange,
    changePasswordErrors,
    authToggleNewPasswordField,
    authToggleConfirmPasswordField,
    showNewPassword,
    showConfirmPassword,
    changingPassword,
    authChangePasswordRequest,
}) => (
    <Form
        size="large"
        error={!!changePasswordErrors}
        onSubmit={() => authChangePasswordRequest(inputs)}
    >
        <Segment stacked>
            <Form.Input
                fluid
                icon="lock"
                iconPosition="left"
                action={
                    <Button
                        type="button"
                        onClick={authToggleNewPasswordField}
                        icon={showNewPassword ? "eye" : "eye slash"}
                    />
                }
                value={inputs.newPassword}
                placeholder="New password"
                type={showNewPassword ? "text" : "password"}
                error={changePasswordErrors && !!changePasswordErrors["newPassword"]}
                onChange={e => authChangePasswordInputChange("newPassword", e.target.value)}
            />
            <Form.Input
                fluid
                icon="lock"
                iconPosition="left"
                action={
                    <Button
                        type="button"
                        onClick={authToggleConfirmPasswordField}
                        icon={showConfirmPassword ? "eye" : "eye slash"}
                    />
                }
                value={inputs.confirmPassword}
                placeholder="Confirm password"
                type={showConfirmPassword ? "text" : "password"}
                error={changePasswordErrors && !!changePasswordErrors["confirmPassword"]}
                onChange={e => authChangePasswordInputChange("confirmPassword", e.target.value)}
            />

            {!!changePasswordErrors && <Message error list={Object.values(changePasswordErrors)} />}

            <Button
                color="teal"
                fluid
                size="large"
                type="submit"
                loading={changingPassword}
                disabled={changingPassword}
            >
                Reset Password
            </Button>
        </Segment>

        <Message>
            Changed your password? <Link to="/auth/signin">Sign In</Link>
        </Message>
    </Form>
);

const mapStateToProps = ({ auth }) => ({
    inputs: auth.changePasswordInputs,
    changePasswordErrors: auth.changePasswordErrors,
    changingPassword: auth.changingPassword,
    showNewPassword: auth.showNewPassword,
    showConfirmPassword: auth.showConfirmPassword,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            authChangePasswordInputChange,
            authChangePasswordRequest,
            authToggleNewPasswordField,
            authToggleConfirmPasswordField,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordForm);
